import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectExperience, experienceListUpdateSelected } from "../../app/actions/experienceActions";
import { registerPanelViewInterest } from "../../app/helpers/intentTrackingHelper";
import ReadMoreReadLess from "../generic-read-more/ReadMoreReadLess";
import L5ModalExperience from "./L5ModalExperience";
import { debugLogPages } from "../../app/helpers/debugHelper";
import { useTranslation } from "react-i18next";
import SemanticSimilarityBadge from "./SemanticSimilarityBadge";

const L4CardExperience = ({ data, moduleSelected }) => {

   debugLogPages(":: L4CardExperience");

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { comparisonExperienceCheckEnabled } = useSelector((state) => state.configuration);
  const [checked] = useState(false);
  const [popupInformationTechIsOpen, setPopupInformationTechIsOpen] = useState(false);

  const isChecked = data.isSelected;

  const handleToggle = () => {
      dispatch(experienceListUpdateSelected(data.id));
    };

  const closeModal = () => {
    setPopupInformationTechIsOpen(false);
  }

  const handleViewExperience = (e) => {
    e.preventDefault();
    dispatch(selectExperience(data));
    registerPanelViewInterest(dispatch, 'experience', data);
    navigate(`/end-user-search/preview-experience`);
  };


  const PreviewImageShow = () => {
  // Imagen por defecto
  //const defaultImg = "/Modulos/TecBC.png";
  const defaultImg = '/images/logo_teccc_no_disponible.png'

  const handleImgError = (e) => {
    // Si la imagen falla, reemplazamos el src por la de defecto
    e.target.src = defaultImg;
    // Opcional: puedes quitar el atributo onError para evitar bucles si la de defecto también falla
    e.target.onerror = null; 
  };

  if (data.ModuleFile_To_Experience && data.ModuleFile_To_Experience.length > 0) {
    return (
      <img 
        src={data.ModuleFile_To_Experience[0].url} 
        alt="file" 
        onError={handleImgError} // <-- El truco está aquí
      />
    );
  } else {
    return (
      <div>
        <img src={defaultImg} width="300px" alt="technology" />
      </div>
    );
  }
};

  const handlePopupSwall = (e) => {
    e.preventDefault();
    registerPanelViewInterest(dispatch, 'experience', data);

    setPopupInformationTechIsOpen(true);
  };

  return (
    <li className="cards__item">
      <div className="card"

      >
        {comparisonExperienceCheckEnabled === "true" && <div>
          <label>
            <input
              type="checkbox"
              checked={isChecked} 
              onChange={handleToggle}
            />
            <div className="espacioComparar">{checked ? `${t('general.card-selected')}` : `${t('general.card-select')}`}</div>
          </label>
        </div>}
        <div className="card__image" onClick={handlePopupSwall}>
          <PreviewImageShow />
        </div>
        <div className="card__content">
          <SemanticSimilarityBadge data={data} moduleKey="experience" />
          <div className="card__title">
            <ReadMoreReadLess
              className='read-more-less'
              buttonClassName='btn-read-more-less'
              expandLabel="Leer más" 
              collapseLabel="Leer menos" 
              limit={100}
            >
              {data && data.name}
            </ReadMoreReadLess>
          </div>
          <br />
          <div className="card__text">
            <ReadMoreReadLess
              className='read-more-less'
              buttonClassName='btn-read-more-less'
              expandLabel="Leer más" 
              collapseLabel="Leer menos" 
              limit={100}
            >
              {data && data.purpose}
            </ReadMoreReadLess>
          </div>
          <button className="btn btn--block button-color-view" onClick={handleViewExperience}>
            {t("buttons.view")}
          </button>
        </div>
      </div>

      <L5ModalExperience
        modalIsOpen={popupInformationTechIsOpen}
        closeModal={closeModal}
        data={data}
        moduleSelected={moduleSelected}
      />

    </li>
  );
};

export default L4CardExperience;
